var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 7,
    width: 178,
    height: 178,
    rx: 89,
    transform: "matrix(-1 0 0 1 178 0)",
    fill: "#C6C3BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 7,
    width: 178,
    height: 178,
    rx: 89,
    transform: "matrix(-1 0 0 1 178 0)",
    stroke: "white",
    strokeWidth: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 37.9902L146.25 67.0021V125.026L96 154.038L45.75 125.026V67.0021L96 37.9902ZM79.2497 92.1446L79.25 131.473L90.4167 137.921V98.5917L79.2497 92.1446ZM56.9167 79.2511V118.579L68.0832 125.026V85.6979L56.9167 79.2511ZM117.982 63.5756L85.1159 82.6381L96 88.9222L128.942 69.9033L117.982 63.5756ZM96 50.8844L63.0583 69.9033L73.962 76.1983L106.828 57.136L96 50.8844Z",
    fill: "#EFECE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/PRODUCT .739a83b88357709fa0ccf2a288b4c2aa.svg";
export { ForwardRef as ReactComponent };